import React from 'react';
import { Moon, Sun, Globe } from 'lucide-react';
import { useTheme, useLanguage } from '@/App';
import { Button } from '@/components/ui/button';

const ThemeLanguageToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const { language, toggleLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2">
      {/* Language Toggle */}
      <Button
        variant="ghost"
        size="sm"
        onClick={toggleLanguage}
        data-testid="language-toggle"
        className="flex items-center gap-2 text-slate-600 dark:text-zinc-300 hover:text-indigo-600 dark:hover:text-indigo-400 dark:hover:text-blue-400"
        title={language === 'id' ? 'Switch to English' : 'Ganti ke Bahasa Indonesia'}
      >
        <Globe className="w-4 h-4" />
        <span className="text-sm font-medium">{language === 'id' ? 'ID' : 'EN'}</span>
      </Button>

      {/* Theme Toggle */}
      <Button
        variant="ghost"
        size="sm"
        onClick={toggleTheme}
        className="text-slate-600 dark:text-zinc-300 hover:text-indigo-600 dark:hover:text-indigo-400 dark:hover:text-blue-400"
        title={theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
      >
        {theme === 'light' ? (
          <Moon className="w-4 h-4" />
        ) : (
          <Sun className="w-4 h-4" />
        )}
      </Button>
    </div>
  );
};

export default ThemeLanguageToggle;
